import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Store from './redux/store';
import { Provider } from 'react-redux';
import "./style.scss"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={Store}>
    <App />
  </Provider>
);
